import React, {Component} from "react"
import PropTypes from "prop-types"
import qs from "qs"

import {store} from "@irati/store"
import authentication from "@irati/auth"
import {getTenantFromPath} from "@irati/identity/services/tenant"
import AuthActions from "@irati/auth/store/actions/AuthActions"
import {updateBrand} from "@irati/ui/src/global/theme"
import intercom from "@irati-web/platform/src/utils/intercom"
import braze from "@irati-web/platform/src/utils/braze"
import sentry from "../../services/sentry"
import {hangPromise} from "../../promise"
import History from "../../history"
import SetAuthStatus from "./AuthedChecker/SetAuthStatus"
import CheckToken from "./AuthedChecker/CheckToken"

export const AuthedCheckerContext = React.createContext({
  setAuthed: () => {},
  load: hangPromise(),
  isAuthed: null
})

export {SetAuthStatus, CheckToken}

export default class AuthedChecker extends Component {
  static propTypes = {
    apps: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired
  }

  static defaultProps = {}

  state = {
    load: hangPromise()
  }

  authed = null

  setAuthed = ({authed, noauth}) => {
    if (noauth) {
      this.setState({load: Promise.resolve()})
    } else if (this.authed !== authed) {
      /** @desc: Not using state as we want this to be fully sync incase 2 nested-routes are mounted */
      this.authed = authed
      const load = this.runCheck(this.authed)
      this.setState({load})
    }
  }

  runCheck = (authed) => {
    if (authed) {
      return this.runAuthedCheck()
    } else {
      return this.runUnAuthedCheck()
    }
  }

  logout = () => {
    const {pathname, href} = location
    const {tags} = qs.parse(href)
    const nextPathname = tags ? `${pathname}?tags=${tags}` : pathname
    History.replace(
      {
        state: {nextPathname},
        pathname: "/welcome/logout"
      },
      this.props.apps.PLATFORM
    )
  }

  runAuthedCheck = () => {
    if (!authentication.isLoggedIn()) {
      return Promise.resolve().then(this.logout)
    } else {
      return store
        .dispatch(AuthActions.resume())
        .then(() => {
          sentry.setIdentity()
          intercom.setIdentity()
          braze.setIdentity()
        })
        .catch(this.logout)
    }
  }

  runUnAuthedCheck = () => {
    if (authentication.isLoggedIn()) {
      return Promise.resolve().then(() => History.replace({pathname: "/"}))
    } else {
      // Retrieves tenant settings (logo + color, etc) and adds to store
      return store
        .dispatch(AuthActions.updateTenant({subdomain: getTenantFromPath()}, {unAuth: true}))
        .catch(() => {
          // handle unknown tenant, we will have a page in the future, for now just showing login form
          updateBrand()
        })
        .then(() => {
          intercom.clearIdentity()
          braze.clearIdentity()
        })
    }
  }

  render() {
    const {children} = this.props
    const authState = {
      load: this.state.load,
      setAuthed: this.setAuthed,
      isAuthed: this.authed
    }

    return <AuthedCheckerContext.Provider value={authState}>{children}</AuthedCheckerContext.Provider>
  }
}
